<template>
  <div class="associatedData">
    <div class="content">
      <Row>
        <Col :span="6">
          <Card class="leftCard">
            <div class="treeDara">
              <div class="bsCode"></div>
              资源数据
            </div>
            <div class="treeCal">
              <Tree
                @on-contextmenu="handleContextMenu"
                :data="layersData"
                :empty-text="loadtree"
                ref="menutree"
              >
                <template slot="contextMenu">
                  <DropdownItem @click.native="handleContextPrewer" v-if=" (contextData.nodeType == '1') || (contextData.resourceName && (contextData.resourceName.indexOf('png') != -1 ||
                contextData.resourceName.indexOf('jpg') != -1 || contextData.resourceName.indexOf('pdf') != -1 ||
                contextData.resourceName.indexOf('bmp') != -1 || contextData.resourceName.indexOf('txt') != -1 ||
                contextData.resourceName.indexOf('gif') != -1))"> 预览 </DropdownItem>
                  <DropdownItem @click.native="handlUploadeRow" v-if="contextData.nodeType == '2'"> 下载 </DropdownItem>
                </template>
              </Tree>
            </div>
          </Card>
        </Col>
        <Col :span="18">
          <Card class="rightCard">
            <div class="treeDara">
              <div class="bsCode"></div>
              数据预览
            </div>
            <div class="mainCalCode">
              <iframe :src="prewerUrl" frameborder="0" v-if="nodeType == '1'" class="iframeCal"></iframe>
              <showdetail v-if="nodeType == '2'" :datas="datas" />
            </div>
          </Card>
        </Col>
      </Row>
    </div>
    <div class="infofooter">
      <div class="oncheck">
        <Button class="infoclose" type="primary" @click.stop="handleClose">关闭</Button>
      </div>
    </div>
    <div class="images imagesArrCal" v-viewer="{ movable: true }" style="visibility: hidden">
      <img v-for="src in imagesArr" :src="src" :key="src" />
    </div>
  </div>
</template>

<script>
import { findAllAssList, downLoadFile, previewFile } from '@/api/index.js';
import showdetail from './showDatial/showdetail.vue';
export default {
  name: 'associatedData',
  data() {
    return {
      contextData: {},
      imagesArr: [],
      prewerUrl: '',
      loadtree: '加载中...',
      layersData: [],
      nodeType: '1',
      datas: {},
    };
  },
  components: {
    showdetail,
  },
  props: ['objData', 'layerid'],
  created() {
    this.getList();
  },
  mounted() {},
  methods: {
    /*
     *@description: 获取表格的数据
     *@author: qqjuanqq
     *@date: 2023-05-11 09:39:16
     *@version: V1.0.0
     */
    getList() {
      var param = {
        layerId: this.objData.id,
      };
      findAllAssList(param).then((res) => {
        if (res.code == 200 && res.success) {
          this.layersData = res.result;
        }
      });
    },
    //右键点击事件
    handleContextMenu(data) {
      this.contextData = data;
    },
    /*
     *@description: 预览
     *@author: qqjuanqq
     *@date: 2023-05-11 16:35:31
     *@version: V1.0.0
     */
    handleContextPrewer() {
      if (this.contextData.nodeType == '1') {
        this.datas = this.contextData;
        this.nodeType = '2';
      } else {
        this.nodeType = '1';
        var param = {
          id: this.contextData.fileId,
        };
        previewFile(param).then((res) => {
          if (res.code == 200 && res.success) {
            if (this.contextData.resourceName) {
              if (
                this.contextData.resourceName.indexOf('png') != -1 ||
                this.contextData.resourceName.indexOf('jpg') != -1 ||
                this.contextData.resourceName.indexOf('bmp') != -1 ||
                this.contextData.resourceName.indexOf('gif') != -1
              ) {
                this.imagesArr = [];
                this.imagesArr.push(res.result);
                const viewer = this.$el.querySelector('.images').$viewer;
                viewer.show();
              } else if (
                this.contextData.resourceName.indexOf('pdf') != -1 ||
                this.contextData.resourceName.indexOf('txt') != -1
              ) {
                this.prewerUrl = res.result;
              }
            }
          }
        });
      }
    },
    /*
     *@description:
     *@author: qqjuanqq
     *@date: 2023-05-11 09:32:31
     *@version: V1.0.0
     */
    handleClose() {
      this.$layer.close(this.layerid);
    },
    /*
     *@description:下载
     *@author: qqjuanqq
     *@date: 2023-05-11 10:50:26
     *@version: V1.0.0
     */
    handlUploadeRow() {
      var param = {
        id: this.contextData.fileId,
      };
      downLoadFile(param).then((res) => {
        const blob = res;
        var url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', this.contextData.resourceName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.associatedData {
  width: 100%;
  height: 100%;
  .content {
    width: 100%;
    height: calc(~'100% - 55px');
    padding: 1rem;
    overflow: hidden auto;
    .treeDara {
      height: 40px;
      line-height: 40px;
      display: flex;
      border-bottom: 1px solid #f2f2f2;
      font-size: 14px;
      .bsCode {
        width: 5px;
        height: 16px;
        border-radius: 5px;
        background: #0099fa;
        margin: 12px 5px 0 0;
      }
    }
    .treeCal {
      height: calc(~'100% - 50px');
      overflow: auto;
    }
    .mainCalCode {
      height: 58vh;
      overflow: auto;
      .iframeCal{
        width: 100%;
        height: 95%;
      }
    }
    /deep/.ivu-row {
      height: 100%;
    }
    /deep/.ivu-card {
      height: 100%;
    }
    .leftCard {
      margin-right: 10px;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    .rightCard {
      height: 100%;
    }
    /deep/.ivu-card-body{
      height: 100%;
    }
  }
  .infofooter {
    width: 100%;
    height: 55px;
    border-top: 1px solid #e8e8e8;
    text-align: right;
    padding-top: 10px;
    .oncheck {
      .infoclose {
        margin-left: 15px;
        margin-right: 20px;
      }
    }
  }
}
.imagesArrCal {
  position: absolute;
  left: -100000;
  top: 0;
  visibility: hidden;
}
</style>




// WEBPACK FOOTER //
// src/components/leftmenu/layers/associatedData.vue